NtechApp.RadioBox = function($radioWrapper) {
    var me = this;
    this._click = new NtechApp.TouchClickEvent();

    this._$radioWrapper = $radioWrapper;
    this._$hidden = $radioWrapper.parent().find(
        "[data-customRadioHiddenId='" + $radioWrapper.attr("data-customRadioId") + "']"
    );
    this._isCheckbox = NtechApp.dom.hasAttribute(this._$hidden.get(0), "data-useRadioAsCheckbox");

    this._click.listen($radioWrapper, "[data-radioTrigger]", function(event) { 
        var $radio = $(event.target).closest("[data-radioVal]");
        var $radioWrapper = $(event.target).closest("[data-customRadioId]");

        if(me._isCheckbox)
            me.selectCheckbox($radio, $radioWrapper);
        else
            me.selectRadio($radio, $radioWrapper);
    });

    return this;
};

NtechApp.RadioBox.EVENT_VALUE_CHANGE = "NtechApp.RadioBox.EventValueChange";

NtechApp.proto(NtechApp.RadioBox, {
    selectRadio: function($radio, $radioWrapper) {
        var newVal = $radio.attr("data-radioVal");
        var radioId = $radioWrapper.attr("data-customRadioId");

        var $radioHidden = $radioWrapper.parent().find("[data-customRadioHiddenId='" + radioId + "']");
        $radioHidden.val(newVal);

        $radioWrapper.find("[data-radioVal] .confirmBox .icon").removeClass("selectedBox");
        $radio.find(".confirmBox .icon").addClass("selectedBox");

        $(this).trigger(NtechApp.RadioBox.EVENT_VALUE_CHANGE, [newVal, $radio]);
    },

    selectCheckbox: function($radio, $radioWrapper) {
        var radioId = $radioWrapper.attr("data-customRadioId");
        var $radioHidden = $radioWrapper.parent().find("[data-customRadioHiddenId='" + radioId + "']");

        $icon = $radio.find(".confirmBox .icon");
        if($icon.hasClass("selectedBox")) {
            $icon.removeClass("selectedBox");
            $radioHidden.val("0");
            $(this).trigger(NtechApp.RadioBox.EVENT_VALUE_CHANGE, [0, $radio]);
        }
        else {
            $icon.addClass("selectedBox");
            $radioHidden.val("1");
            $(this).trigger(NtechApp.RadioBox.EVENT_VALUE_CHANGE, [1, $radio]);
        }
    },

    getRadioWrapper: function() {
        return this._$radioWrapper;
    },

    val: function(val) {
        if(typeof val == "undefined") {
            return this._$hidden.val();
        }

        var $radio = this._$radioWrapper.find("[data-radioVal='" + val + "']");
        this.selectRadio($radio, this._$radioWrapper);
    }
});